// src/pages/Articulos/Articulos.js
import React, { useState } from 'react';
import api from '../../services/api';
import { useToast } from '../../components/Toast/ToastProvider';
import CreacionArticuloForm from '../../components/Forms/CreacionArticuloForm';
import BarraBusqueda from '../../components/Busqueda/BarraBusqueda'; // <-- Importamos el nuevo componente

function Articulos() {
  const { showToast } = useToast();
  // --- Estados para controlar el flujo ---
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchPerformed, setSearchPerformed] = useState(false); // Para saber si ya se buscó algo
  const [showCreateForm, setShowCreateForm] = useState(false); // Para mostrar/ocultar el formulario

  // --- Función para manejar la búsqueda ---
  const handleSearch = async () => {
    if (!searchQuery.trim()) return;

    setIsLoading(true);
    setSearchPerformed(true);
    setShowCreateForm(false);
    setSearchResults([]);

    try {
        // El token se inyecta automáticamente y el 401 se maneja de forma global en api.js
        const { data } = await api.get(`/articulos/buscar?q=${encodeURIComponent(searchQuery)}`);
        setSearchResults(data);
    } catch (error) {
        showToast(
            error.response?.data?.error || 'Error al buscar artículos.',
            'danger'
        );
    } finally {
        setIsLoading(false);
    }
};

  // --- Renderizado Condicional de la UI ---
  return (
    <div className="container-fluid">
      <h1 className="mt-4">Control y Alta de Artículos</h1>

      {/* --- Módulo de Búsqueda --- */}
      <div className="card shadow-sm mb-4">
        <div className="card-header">
          <h3>1. Buscar Artículo Existente</h3>
        </div>
        <div className="card-body">
          <BarraBusqueda 
            query={searchQuery}
            setQuery={setSearchQuery}
            onSearch={handleSearch}
            isLoading={isLoading}
          />
        </div>
      </div>

      {/* --- Módulo de Resultados --- */}
      {searchPerformed && !isLoading && (
        <div className="card shadow-sm mb-4">
          <div className="card-header">
            <h3>Resultados de la Búsqueda</h3>
          </div>
          <div className="card-body">
            {searchResults.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>Código SAP</th>
                    <th>Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map(articulo => (
                    <tr key={articulo.ItemCode}>
                      <td>{articulo.ItemCode}</td>
                      <td>{articulo.ItemName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="text-center">
                <p>No se encontraron artículos que coincidan con "<strong>{searchQuery}</strong>".</p>
                <button className="btn btn-success" onClick={() => setShowCreateForm(true)}>
                  + Crear Nuevo Artículo
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* --- Módulo de Creación (se muestra condicionalmente) --- */}
      {showCreateForm && (
        <div className="card shadow-sm">
          <div className="card-header">
            <h3>2. Crear Nuevo Artículo</h3>
          </div>
          <div className="card-body">
            <CreacionArticuloForm />
          </div>
        </div>
      )}
    </div>
  );
}

export default Articulos;